import React, { useEffect, useState } from 'react';
import PageHeader from './PageHeader';
import styled from 'styled-components';
import { getStaticPageData, getInitialPageData } from '../../utils/staticDataLoader';
import client from '../../sanityClient';

const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem 3rem;
`;

const ContentSection = styled.div`
  margin-top: 2rem;
  
  h2 {
    color: ${({ theme }) => theme.colors.primary};
    margin-bottom: 1rem;
    margin-top: 2rem;
  }
  
  p {
    margin-bottom: 1rem;
    line-height: 1.6;
    white-space: pre-line;
  }
  
  ul {
    margin-bottom: 1rem;
    padding-left: 1.5rem;
    
    li {
      margin-bottom: 0.5rem;
      line-height: 1.6;
    }
  }
`;

const StaticPageTemplate = ({ 
  pageName, 
  query, 
  defaultData, 
  children,
  customContent 
}) => {
  const [pageData, setPageData] = useState(() => 
    getInitialPageData(pageName, defaultData)
  );
useEffect(() => {
  const loadData = async () => {
    try {
      // Fetch live Sanity data first
      const data = await client.fetch(query);

      console.log(`${pageName} Sanity data:`, data);

      if (data) {
        setPageData({
          ...defaultData,
          ...data
        });
        return;
      }

      // Fallback to static data
      const staticData = await getStaticPageData(pageName);

      if (staticData) {
        setPageData({
          ...defaultData,
          ...staticData
        });
      }
    } catch (error) {
      console.error(`Error loading ${pageName} data:`, error);

      try {
        const staticData = await getStaticPageData(pageName);
        if (staticData) {
          setPageData({
            ...defaultData,
            ...staticData
          });
        }
      } catch {
        // keep defaultData
      }
    }
  };

  loadData();
}, [pageName, query, defaultData]);
  return (
    <div>
      {console.log("Policies customContent pageData:", pageData)}
      <PageHeader 
        title={pageData.title} 
        subtitle={pageData.subtitle}
      />
      
      <PageContainer>
        <ContentSection>
          {pageData.introText && <p>{pageData.introText}</p>}

          {customContent ? customContent(pageData) : children}
        </ContentSection>
      </PageContainer>
    </div>
  );
};

export default StaticPageTemplate;
